import React from 'react';
import './PendingModulesList.scss';
import PendingModule from './PendingModule/PendingModule';

export interface PendingModulesListProps {
    pendingModulesList: Array<{ name: string, navUrl: string }>;
}

const PendingModulesList: React.FC<PendingModulesListProps> = (props) => {
    return (
        <div className='pendingModulesList'>
            <h2 className='pmHeading'>Pending Modules</h2>
            <p className='pmInfo'>Complete all the pending modules to proceed with E-Sign</p>
            <div className='pmList'>
                {
                    props.pendingModulesList.map((module, index) => (
                        <PendingModule key={index} moduleName={module.name} moduleLink={module.navUrl} />
                    ))
                }
            </div>
        </div>
    );
}

export default PendingModulesList;